export default __webpack_public_path__ + "static/media/nomessages.38307a01.svg";